import styled from "styled-components";
import { black, lightGray, navy } from "../../utils/color";

export const SubTitle = styled.h2`
	font-family: "Noto Sans KR", sans-serif;
	font-size: 15px;
	margin: 0 20px 20px 20px;
	color: ${(props) => (props.color ? props.color : black)};
`;

export const Title = styled.h1`
	font-family: "Noto Sans KR", sans-serif;
	font-size: 28px;
	margin: 15px 20px 15px 20px;
	text-align: center;
	color: ${black};
`;

export const Header = styled.header`
	width: 100%;
	height: 75px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${lightGray};
	border-bottom: 1px solid #636363;
`;
